import { defineStore } from 'pinia'

import axios from "@axios"
import {reportError} from "@/plugins/misc"

const baseUrl = `/media/`

export const useMediaStore = defineStore({
  id: 'media',
  state: () => ({
    media: JSON.parse(localStorage.getItem('media')) || [],
  }),
  actions: {

    async getMedia(restaurantId, userGroupId) {
      try {
        let res = await axios.get(baseUrl, {
          params:{
            restaurantId: restaurantId,
            userGroupId: userGroupId
          }
        })
        this.media = res.data
        localStorage.setItem('media', JSON.stringify(this.media))
      } catch (error) {
        console.log("ERROR 563", error)
        reportError("stats.store.js:media", error.message, null,null,null, error)
      }
    },

    async deleteMedia(imageId) {
      try {
        let res = await axios.delete(baseUrl+imageId, {
          params:{
          }
        })

        //delete item from media
        this.media = this.media.filter(item => item.imageId !== imageId)
        localStorage.setItem('media', JSON.stringify(this.media))
      } catch (error) {
        console.log("ERROR 563", error)
        reportError("stats.store.js:media", error.message, null,null,null, error)
      }
    },

    async cropMedia(imageId, coordinates) {
      try {
        let res = await axios.put(baseUrl+'/'+imageId,{
          crop: true,
          coordinates: coordinates
        })

        if(res.data) {
          let theImage = this?.media?.find(({imageId}) => imageId === imageId)
          if (theImage) Object.assign(theImage, res.data)
          localStorage.setItem('media', JSON.stringify(this.media))
        }
      } catch (error) {
        console.log("ERROR 563", error)
        reportError("stats.store.js:media", error.message, null,null,null, error)
      }
    }

  }
})
